import { Injectable } from '@angular/core';

import { _PageService } from 'src/app/infrastructure/services/page-services/_page.service';
import { RouteActionParam, routeActionParam } from 'src/app/infrastructure/services/page-services/models/return-page-query-param';
import { routePage } from 'src/app/infrastructure/services/route-service/models/route-page';
import { IMessageListData, messageListData } from '../models/message-list-data';

// Navigatie naar de berichtpagina. Die staat in de domaincontext (/domains/{dauGuid}/messages/{key}), zoals de chat:
// de dauGuid komt uit de rij (eigen DomainUser in het domain van het bericht), zodat het centrale overzicht op Home
// berichten uit elk domain kan openen. Verzenden = dialoog, geen pagina.
@Injectable({
    providedIn: 'root'
})
export class MessagePageService
    extends _PageService
{
    constructor() {
        super(null);
    }

    override pageCreate_goto(): void {
        throw new Error('Message send is a dialog, not a page');
    }

    override pageRoute_goto(item: IMessageListData, keep?: RouteActionParam, routeParams?: {[key: string]: string}): void {
        this.pageMessage_goto(item[messageListData.guid], item[messageListData.requestedDomainUser_guid], keep, routeParams);
    }

    pageMessage_goto(messageGuid: string, dauGuid: string | null, keep?: RouteActionParam, routeParams?: {[key: string]: string}): void {
        const __dauGuid = dauGuid ?? this._activatedRouteService?.routeKeys?.dauGuid;
        this.page_goto(routePage.message, {key: messageGuid, dauGuid: __dauGuid}, [keep ?? routeActionParam.none], routeParams);
    }
}
